export interface RichTextSectionProps {
  title: string
  content: string
  lastUpdate?: string
}

export const RichTextSection: React.FC<RichTextSectionProps> = ({
  title,
  content,
  lastUpdate,
}) => {
  return (
    <section className="px-2 py-24 text-center">
      <h1 className="mb-6 font-display text-4xl font-black leading-tight md:text-5xl">
        {title}
      </h1>
      {lastUpdate && (
        <p className="font-body font-normal md:text-lg">
          Última actualització: {lastUpdate}
        </p>
      )}
      <div
        className="markdown mt-20 text-left font-body"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </section>
  )
}
